<template>
  <div class="site-view">
    <section class="site-text">
      <div class="feedback container">
        <p>This engagement event has now finished.</p>
      </div>
    </section>

    <section
      class="site-text"
      v-if="thankYou === false"
      style="display: none !important"
    >
      <div class="feedback container">
        <h1>Have your say</h1>
        <p>
          This survey asks for your opinion on our plans to improve the
          opportunities for safer cycling between Gloucester and Cheltenham
          along the B4063. Your answers are anonymous and any personal data will
          be treated as confidential and in accordance with UK GDPR laws and
          Gloucestershire County Council’s data protection policy which can be
          read here<a
            href="https://www.gloucestershire.gov.uk/council-and-democracy/data-protection/general-data-protection-regulation-gdpr/"
            target="_blank"
          >
            - General Data Protection Regulation (GDPR)</a
          >. You will only be contacted in relation to this survey if you sign
          up for the B4063 Cycleway scheme news bulletin at the end of the
          survey. So we can analyse your responses we will need to share your
          information with our partner Atkins.
        </p>
        <p>
          The survey responses will be combined into a report which will be read
          by councillors and senior officers at Gloucestershire County Council.
          The responses will help us determine why the scheme is important to
          you, how the scheme can help tackle climate change and improve
          congestion between Cheltenham and Gloucester, as well as improving
          health and wellbeing. You can read the full privacy notice here:<a
            href="https://www.gloucestershire.gov.uk/council-and-democracy/data-protection/privacy-notices/"
            target="_blank"
          >
            Privacy notices - Gloucestershire County Council</a
          >
        </p>

        <!-- Feedback Queastions - Section 01 ----------------------------------------------------------------------------------------->
        <div class="feedback-section">
          <h2>Section 1 - Before we start</h2>
          <ol start="1">
            <li>
              <p>
                We will manage all data collected through this survey in line
                with the GCC GDPR policy, are you happy to proceed?
              </p>
              <form>
                <div>
                  <label for="question_01_01">Yes</label>
                  <input
                    type="radio"
                    name="section_01_01"
                    id="question_01_01"
                    value="yes"
                    v-model="answers.section01[0]"
                  />
                </div>
                <div>
                  <label for="question_01_02">No</label>
                  <input
                    type="radio"
                    name="section_01_01"
                    id="question_01_02"
                    value="no"
                    v-model="answers.section01[0]"
                  />
                </div>
              </form>
            </li>
            <li>
              <p>
                Have you read through the information about the scheme on the
                website, including maps and illustrations of the planned
                Cycleway?
              </p>
              <form>
                <div>
                  <label for="question_02_01">Yes</label>
                  <input
                    type="radio"
                    name="section_01_02"
                    id="question_02_01"
                    value="yes"
                    v-model="answers.section01[1]"
                  />
                </div>
                <div>
                  <label for="question_02_02">No</label>
                  <input
                    type="radio"
                    name="section_01_02"
                    id="question_02_02"
                    value="no"
                    v-model="answers.section01[1]"
                  />
                </div>
              </form>
            </li>
            <li>
              <p>In what capacity are you responding to this survey?</p>
              <form>
                <select
                  style="display: block !important"
                  v-model="answers.section01[2]"
                >
                  <option
                    v-for="(select, index) in formTypes.slectionBoxsec1"
                    :key="`section01_q3_${index}`"
                    :value="select"
                  >
                    {{ select }}
                  </option>
                </select>
                <input
                  type="text"
                  v-if="answers.section01[2] === 'Other (please state) '"
                  class="textFeedback"
                  style="margin-top: 40px"
                  v-model="answers.section01_3_comments"
                />
              </form>
            </li>
          </ol>
          <div v-if="answers.section01[1] === 'no'">
            <p>
              (If you have answered ‘no’ we recommend you take a look at the
              other information on this website and come back to this survey
              later.)
            </p>
            <div
              style="margin-bottom: 30px"
              class="feedback-btn btn btn-primary"
            >
              <router-link class="backHome" to="/site/homePage"
                >Back to Home</router-link
              >
            </div>
          </div>
          <div
            class="buttons"
            v-if="
              sectionsSubmitted[0].submitted === false &&
              answers.section01[0] === 'yes' &&
              answers.section01[1] === 'yes'
            "
          >
            <button
              class="feedback-btn btn btn-primary"
              @click="() => setSectionSubmit(0)"
            >
              Next Section
            </button>
            <p>Continue to next section or submit feedback below</p>
          </div>
          <hr />
        </div>

        <!-- Feedback Main Survey Section -->
        <!-- This will turn on when user clicks yes to section 01-01 -->

        <!-- SECTION 02 ----------------------------------------------------------------------------------------->
        <div id="feeback-survey-main" v-if="sectionsSubmitted[0].submitted">
          <div class="feedback-section">
            <h2>Section 2 - The B4063 Cycleway</h2>
            <p>
              In this section please provide your views on the proposed Cycleway
            </p>
            <ol start="4">
              <li
                v-for="(question, index) in questions.section02.Q3_7.questions"
                :key="`section_02_` + index"
              >
                <p>{{ question }}</p>
                <form v-if="index === 0">
                  <!-- Inputs for first question -->
                  <div
                    v-for="form in formTypes.satisfaction"
                    :key="`section02_Q${index}_${form}`"
                  >
                    <label :for="`section02_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section02_${index}`"
                      :id="`section02_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section02_3to7[index]"
                    />
                  </div>
                </form>
                <form v-if="index === 1">
                  <div
                    v-for="form in formTypes.yesMore"
                    :key="`section02_2_Q${index}_${form}`"
                  >
                    <label :for="`section02_2_Q${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section02_2_${index}`"
                      :id="`section02_2_Q${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section02_3to7[1]"
                    />
                  </div>
                </form>
                <!-- Inputs for Next question -->
                <form v-if="index > 1 && index < 5">
                  <div
                    v-for="form in formTypes.yes_no"
                    :key="`section02_Q${index}_${form}`"
                  >
                    <label :for="`section02_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section02_${index}`"
                      :id="`section02_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section02_3to7[index]"
                    />
                  </div>
                </form>
                <div v-if="index === 1 && answers.section02_3to7[1] === 'no'">
                  <p class="subq2" style="margin-top: 30px">
                    If no – What would encourage you to use the cycleway?
                  </p>
                  <input
                    type="text"
                    class="textFeedback"
                    style="margin-top: 10px"
                    v-model="answers.section02_text[1]"
                  />
                </div>
                <!--question 02-6 text box-->
                <div
                  v-if="
                    index === 0 &&
                    (answers.section02_3to7[0] === 'dissatisfied' ||
                      answers.section02_3to7[0] === 'very dissatisfied')
                  "
                >
                  <p class="subq2" style="margin-top: 30px">
                    If dissatisfied or very dissatisfied – Please tell us why
                  </p>
                  <input
                    type="text"
                    class="textFeedback"
                    style="margin-top: 10px"
                    v-model="answers.section02_text[0]"
                  />
                </div>
                <!--question 02-6 text box-->
                <div v-if="index === 2 && answers.section02_3to7[2] === 'yes'">
                  <p class="subq2" style="margin-top: 30px">
                    If yes – please explain why?
                  </p>
                  <input
                    type="text"
                    class="textFeedback"
                    style="margin-top: 10px"
                    v-model="answers.section02_text[2]"
                  />
                </div>
                <div v-if="index === 3">
                  <p class="subq2" style="margin-top: 30px">
                    If there are specific features about the scheme proposals
                    that you wish to tell us about please do so here
                  </p>
                  <input
                    type="text"
                    class="textFeedback"
                    style="margin-top: 10px"
                    v-model="answers.section02_text[3]"
                  />
                </div>
              </li>
            </ol>
            <!-- Section 02 question 08 specific -->
            <ol start="8">
              <li>
                <p>
                  Please tell us to what level you agree or disagree with the
                  statements by ticking the boxes below:
                </p>
                <ul>
                  <li
                    v-for="(question, index) in questions.section02.Q8
                      .questions"
                    :key="`section_02_8` + index"
                  >
                    <p>{{ question }}</p>
                    <form>
                      <div
                        v-for="form in formTypes.agreement"
                        :key="`section02_Q8_${index}_${form}`"
                      >
                        <label :for="`section02_Q8_${index}_${form}`">{{
                          form
                        }}</label>
                        <input
                          type="radio"
                          :name="`section02_Q8_${index}`"
                          :id="`section02_Q8_${index}_${form}`"
                          :value="`${form}`"
                          v-model="answers.section02_8[index]"
                        />
                      </div>
                    </form>
                  </li>
                </ul>
              </li>
            </ol>
            <div
              class="buttons"
              v-if="sectionsSubmitted[1].submitted === false"
            >
              <button
                class="feedback-btn btn btn-primary"
                @click="() => setSectionSubmit(1)"
              >
                Next Section
              </button>
              <p>Continue to next section or submit feedback below</p>
            </div>
            <hr />
          </div>

          <!-- SECTION 03a ----------------------------------------------------------------------------------------->
          <div class="feedback-section" v-if="sectionsSubmitted[1].submitted">
            <h2>Section 3a - About you</h2>
            <p>
              Thank you for taking the time to answer questions about the B4063
              Cycleway. We would now like to ask you questions about your travel
              behaviours:
            </p>
            <ol start="9">
              <li
                v-for="(question, index) in questions.section03a.questions"
                :key="`section3a_${index}`"
              >
                <p>{{ question }}</p>
                <form v-if="index === 0">
                  <div
                    v-for="form in formTypes.yesNo"
                    :key="`section03a_Q9_${form}`"
                  >
                    <label :for="`section03a_Q9_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section03a_Q9_${index}`"
                      :id="`section03a_Q9_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section03a_9to10[index]"
                    />
                  </div>
                </form>
                <form v-if="index === 1">
                  <div
                    v-for="form in formTypes.yesNoMaybe"
                    :key="`section03a_Q10_${form}`"
                  >
                    <label :for="`section03a_Q10_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section03a_Q10_${index}`"
                      :id="`section03a_Q10_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section03a_9to10[index]"
                    />
                  </div>
                </form>
                <form v-if="index === 2">
                  <div
                    v-for="form in formTypes.yesNoComment"
                    :key="`section03a_Q11_${form}`"
                  >
                    <label :for="`section03a_Q11_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section03a_Q11_${index}`"
                      :id="`section03a_Q11_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section03a_11.radio"
                    />
                  </div>
                  <textarea
                    v-if="answers.section03a_11.radio"
                    class="feedback-text"
                    type="textarea"
                    align="top"
                    v-model="answers.section03a_11.comments"
                    style="margin-top: 30px"
                  />
                </form>
                <form v-if="index === 3">
                  <div
                    v-for="(q, j) in questions.section03b_12"
                    :key="`section03a_Q12_${q}`"
                  >
                    <label
                      class="selection-label"
                      :for="`section03a_Q12_${q}`"
                      >{{ q }}</label
                    >
                    <select
                      :id="`section03a_Q12_${q}`"
                      style="display: block !important"
                      v-model="answers.section03a_12[j]"
                    >
                      <option
                        v-for="(opt, o) in formTypes.selectionBox1"
                        :key="`section03a_Q12_${q}_${o}`"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>
                  </div>
                </form>
                <form v-if="index === 4">
                  <div>
                    <select
                      :id="`section03a_Q13`"
                      style="display: block !important"
                      v-model="answers.section03a_13"
                    >
                      <option
                        v-for="(opt, o) in formTypes.selectionBox2"
                        :key="`section03a_Q13_${o}`"
                        :value="opt"
                      >
                        {{ opt }}
                      </option>
                    </select>
                  </div>
                </form>
                <form v-if="index === 5">
                  <select
                    :id="`section03a_Q14`"
                    style="display: block !important; margin-bottom: 30px"
                    v-model="answers.section03a_14.select"
                  >
                    <option
                      v-for="(opt, o) in formTypes.selectionBox3"
                      :key="`section03a_Q14_${o}`"
                      :value="opt"
                    >
                      {{ opt }}
                    </option>
                  </select>
                  <textarea
                    v-if="
                      answers.section03a_14.select === 'Other (please tell us)'
                    "
                    class="feedback-text"
                    type="textarea"
                    align="top"
                    v-model="answers.section03a_14.comments"
                  />
                </form>
                <form v-if="index === 6">
                  <div
                    v-for="form in formTypes.yesNo"
                    :key="`section03a_Q15_${form}`"
                  >
                    <label :for="`section03a_Q15_${index}_${form}`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section03a_Q15_${index}`"
                      :id="`section03a_Q15_${index}_${form}`"
                      :value="`${form}`"
                      v-model="answers.section03a_14to15[0]"
                    />
                  </div>
                </form>
                <form v-if="index === 7">
                  <textarea
                    class="feedback-text"
                    type="textarea"
                    align="top"
                    v-model="answers.section03a_14to15[1]"
                  />
                </form>
              </li>
            </ol>
            <div
              class="buttons"
              v-if="sectionsSubmitted[2].submitted === false"
            >
              <button
                class="feedback-btn btn btn-primary"
                @click="() => setSectionSubmit(2)"
              >
                Next Section
              </button>
              <p>Continue to next section or submit feedback below</p>
            </div>
            <hr />
          </div>
          <!-- SECTION 03b ----------------------------------------------------------------------------------------->

          <div class="feedback-section" v-if="sectionsSubmitted[2].submitted">
            <h2>Section 3b - COVID-19 travel behaviours</h2>
            <p>
              The COVID-19 pandemic has had many impacts on our daily lives,
              including when and how we travel. With this in mind we would like
              to ask your views on whether COVID-19 has, or will, change your
              travel behaviours.
            </p>
            <ol start="17">
              <li>
                <p>
                  In what ways do you think COVID-19 will change the way you
                  will travel in future, do you agree or disagree with the
                  following statements:
                </p>
                <ul>
                  <li
                    v-for="(question, index) in questions.section03b.questions"
                    :key="`section_03b_Q17_` + index"
                  >
                    <p>{{ question }}</p>
                    <form>
                      <div
                        v-for="form in formTypes.agreement"
                        :key="`section_03b_Q17_${index}_${form}`"
                      >
                        <label :for="`section_03b_Q17_${index}_${form}`">{{
                          form
                        }}</label>
                        <input
                          type="radio"
                          :name="`section_03b_Q17_${index}`"
                          :id="`section_03b_Q17_${index}_${form}`"
                          :value="`${form}`"
                          v-model="answers.section03b_17[index]"
                        />
                      </div>
                    </form>
                  </li>
                </ul>
              </li>
            </ol>
            <div
              class="buttons"
              v-if="sectionsSubmitted[3].submitted === false"
            >
              <button
                class="feedback-btn btn btn-primary"
                @click="() => setSectionSubmit(3)"
              >
                Next Section
              </button>
              <p>Continue to next section or submit feedback below</p>
            </div>
            <hr />
          </div>

          <!-- SECTION 04 ----------------------------------------------------------------------------------------->
          <div class="feedback-section" v-if="sectionsSubmitted[3].submitted">
            <h2>Section 4 – Any other comments</h2>
            <ol start="18">
              <li>
                <p>
                  Please provide any additional comments/feedback you have
                  regarding the scheme.
                </p>
                <form id="question17">
                  <textarea
                    class="feedback-text"
                    type="textarea"
                    align="top"
                    v-model="answers.section04_18"
                  />
                </form>
              </li>
            </ol>
            <div
              class="buttons"
              v-if="sectionsSubmitted[4].submitted === false"
            >
              <button
                class="feedback-btn btn btn-primary"
                @click="() => setSectionSubmit(4)"
              >
                Next Section
              </button>
              <p>Continue to next section or submit feedback below</p>
            </div>
            <hr />
          </div>

          <!-- SECTION 05 ----------------------------------------------------------------------------------------->
          <div class="feedback-section" v-if="sectionsSubmitted[4].submitted">
            <h2>Section 5 – Equality monitoring</h2>
            <p>
              The council is committed to ensuring that our services are
              delivered fairly. We are asking you to answer the following
              questions about yourself so that we can make sure that this is
              happening. The information that you provide will be kept
              confidential and only used for the purpose we have outlined.
            </p>
            <p>
              You do not have to answer these questions, and it will make no
              difference at all to the way the council treats you if you prefer
              not to answer these questions.
            </p>
            <ul>
              <li>
                <p>Gender</p>
                <p class="subq1">Are you?</p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <div
                    v-for="(form, index) in formTypes.genders"
                    :key="`section05_q1_${index}`"
                  >
                    <label :for="`section05_q1_${index}_form`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section05_q1`"
                      :id="`section05_q1_${index}_form`"
                      :value="`${form}`"
                      v-model="answers.section05_1to5[0]"
                    />
                  </div>
                </form>
              </li>
              <li>
                <p>Gender re-assignment</p>
                <p class="subq1">
                  Is your gender identity the same as the gender you were
                  assigned at birth?
                </p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <div
                    v-for="(form, index) in formTypes.yesNoPrefer"
                    :key="`section05_q2_${index}`"
                  >
                    <label :for="`section05_q2_${index}_form`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section05_q2`"
                      :id="`section05_q2_${index}_form`"
                      :value="`${form}`"
                      v-model="answers.section05_1to5[1]"
                    />
                  </div>
                </form>
              </li>
              <li>
                <p>Age</p>
                <p class="subq1">What is your age?</p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <div
                    v-for="(form, index) in formTypes.ages"
                    :key="`section05_q3_${index}`"
                  >
                    <label :for="`section05_q3_${index}_form`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section05_q3`"
                      :id="`section05_q3_${index}_form`"
                      :value="`${form}`"
                      v-model="answers.section05_1to5[2]"
                    />
                  </div>
                </form>
              </li>
              <li>
                <p>Ethnicity</p>
                <p class="subq2">
                  Ethnic origin categories are not about nationality, place of
                  birth or citizenship. They are about the group to which you as
                  an individual perceive you belong.
                </p>
                <p class="subq1">
                  Please indicate your ethnic origin by ticking the appropriate
                  box
                </p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <ul class="ethnicity">
                    <li
                      v-for="(ethnicity, index) in formTypes.ethnicity"
                      :key="`section05_q4_${index}`"
                      class="categoryOptions"
                    >
                      <p>{{ ethnicity.ethnic }}</p>
                      <div
                        v-for="(ethnic, j) in ethnicity.region"
                        :key="`section05_q4_${index}_${j}`"
                        style="padding: 6px 0; margin-left: 20px"
                      >
                        <label :for="`section05_q4_${index}_check${j}`">{{
                          ethnic
                        }}</label>
                        <input
                          type="radio"
                          :id="`section05_q4_${index}_check${j}`"
                          name="section05_q4_ethnicity_check"
                          :value="ethnic"
                          v-model="answers.section05_1to5[3]"
                        />
                      </div>
                    </li>
                  </ul>
                </form>
              </li>
              <li>
                <p>Other ethnicity</p>
                <p class="subq2">(Other - please state)</p>
                <form id="section05_q5">
                  <input
                    class="textFeedback"
                    type="text"
                    v-model="answers.section05_6"
                  />
                </form>
              </li>
              <li>
                <p>Disability</p>
                <p class="subq1">Do you consider yourself to be disabled?</p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <div
                    v-for="(form, index) in formTypes.yesNoPrefer"
                    :key="`section05_q6_${index}`"
                  >
                    <label :for="`section05_q6_${index}_form`">{{
                      form
                    }}</label>
                    <input
                      type="radio"
                      :name="`section05_q6`"
                      :id="`section05_q6_${index}_form`"
                      :value="`${form}`"
                      v-model="answers.section05_1to5[4]"
                    />
                  </div>
                </form>
              </li>
              <li>
                <p>Disability type</p>
                <p class="subq1">
                  Please provide additional information by selecting the box(s)
                  that apply.
                </p>
                <p class="subq2">(please select all that apply)</p>
                <ul>
                  <li
                    v-for="(question, index) in formTypes.disability"
                    :key="`section05_q6_${index}`"
                    style="list-style-type: none; margin: 15px 0 !important"
                  >
                    <form>
                      <div>
                        <label :for="`section05_q7_input_${index}`">{{
                          question
                        }}</label>
                        <input
                          type="radio"
                          :id="`section05_q7_input_${index}`"
                          name="section05_q7_disabilityType"
                          :value="question"
                          v-model="answers.section05_7[index]"
                        />
                      </div>
                    </form>
                  </li>
                  <li
                    v-if="answers.section05_7[6]"
                    style="list-style-type: none"
                  >
                    <p>Other Disability</p>
                    <p class="subq2">Other - Please state</p>
                    <form>
                      <input
                        class="textFeedback"
                        type="text"
                        v-model="answers.section05_7_other"
                      />
                    </form>
                  </li>
                </ul>
              </li>
              <li>
                <p>Sexual orientation</p>
                <p class="subq1">
                  How would you describe your sexual orientation?
                </p>
                <p class="subq2">(please select one answer)</p>
                <form>
                  <div
                    v-for="(question, index) in formTypes.sexual"
                    :key="`section05_q8_${index}`"
                  >
                    <label :for="`section05_q8_${index}`">{{ question }}</label>
                    <input
                      type="radio"
                      :id="`section05_q8_${index}`"
                      name="section05_q8_sexualOrientation"
                      :value="question"
                      v-model="answers.section05_8"
                    />
                  </div>
                </form>
              </li>
            </ul>

            <hr />
          </div>
        </div>

        <!-- SECTION 06 ----------------------------------------------------------------------------------------->
        <div class="buttons">
          <button
            class="feedback-btn btn btn-primary"
            @click="() => submitFeedback()"
          >
            Submit Feedback
          </button>
        </div>
        <div class="feedback-section">
          <h2>Further information and B4063 Bulletin</h2>
          <p>
            If you would like to sign up to receive our B4063 Bulletin for
            updates on the B4063 Cycleway scheme,
            <a
              href="https://www.gloucestershire.gov.uk/highways/major-projects-list/b4063-gloucester-to-cheltenham-cycle-improvements-scheme/"
              target="_blank"
              >please click</a
            >.
          </p>
          <p>
            You can also email us at
            <a href="mailto:majorprojects@gloucestershire.gov.uk"
              >majorprojects@gloucestershire.gov.uk
            </a>
            for more information.
          </p>
        </div>
      </div>
    </section>
    <section class="site-text" v-show="thankYou">
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="success-msg">
              <h1 class="large">Thank You.</h1>
              <h2>Your feedback has been submitted.</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="buttons">
              <button
                class="feedback-btn btn btn-primary"
                @click.prevent="goBack()"
                v-show="thankYou"
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from "@/components/customPages/components/footer.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "FeedbackSurvey",
  components: {
    SiteFooter,
  },
  data() {
    return {
      sectionsSubmitted: [
        { submitted: false },
        { submitted: false },
        { submitted: false },
        { submitted: false },
        { submitted: false },
        { submitted: false },
      ],
      formTypes: {
        yesMore: ["yes, more often", "yes", "no", "unsure"],

        slectionBoxsec1: [
          "",
          "Resident – I live near the scheme ",
          "Non-local resident – I ride this route",
          "Business owner or CEO/MD of a business near the scheme",
          "Local politician or political candidate",
          "Local employee – I work near the scheme",
          "Other (please state) ",
        ],
        satisfaction: [
          "very satisfied",
          "satisfied",
          "dissatisfied",
          "very dissatisfied",
        ],
        yes_no: ["yes", "no", "unsure"],
        yesNo: ["yes", "no"],
        yesNoComment: ["yes", "no", "unsure"],
        yesNoMaybe: ["yes", "no", "maybe"],
        agreement: [
          "strongly agree",
          "agree",
          "disagree",
          "strongly disagree",
          "dont know",
        ],
        selectionBox1: [
          "",
          "more than once per day",
          "once per day",
          "2-3 times per week",
          "weekly",
          "monthly",
          "less than once a month",
          "never",
          "not applicable",
        ],
        selectionBox2: [
          "",
          "I can’t ride a bicycle",
          "Total beginner – I have just started to ride / I have not cycled for a long time",
          "Novice – I can ride a bicycle but I am not very confident/ I cycle for leisure",
          "Advanced – I cycle for fun as a hobby/commute to work on a bicycle",
          "Semi-professional – member of a local cycling club and plan to compete in the future",
          "Not applicable",
        ],
        selectionBox3: [
          "",
          "In a park/enclosed space",
          "Off road on a cycle track",
          "On the road",
          "Mixture of on and off road",
          "In a gym",
          "Other (please tell us)",
        ],
        genders: ["Male", "Female", "Non-binary", "Other", "Prefer not to say"],
        yesNoPrefer: ["Yes", "No", "Prefer not to say"],
        ages: [
          "16-24",
          "25-29",
          "30-34",
          "35-39",
          "40-44",
          "45-49",
          "50-54",
          "55-59",
          "60-64",
          "65+",
          "Prefer not to say",
        ],
        ethnicity: [
          {
            ethnic: "White",
            region: [
              "English",
              "Welsh",
              "Scottish",
              "Northen Irish",
              "Gypsy or Irish Traveller",
              "Any other White background",
            ],
          },
          {
            ethnic: "Mixed/Multiple ethnic groups",
            region: [
              "White and Black Caribbean",
              "White and Black African",
              "White and Asian",
              "Any other mixed background",
            ],
          },
          {
            ethnic: "Asian/Asian British",
            region: [
              "Indian",
              "Pakistani",
              "Bangladeshi",
              "Chinese",
              "Any other Asian background",
            ],
          },
          {
            ethnic: "Black/ African/ Caribbean/ Black British",
            region: [
              "African",
              "Caribbean",
              "Any other Black/African/Caribbean Background",
            ],
          },
          {
            ethnic: "Other ethnic group",
            region: ["Arab", "Any other ethnic group"],
          },
          {
            ethnic: "",
            region: ["Prefer not to say"],
          },
        ],
        disability: [
          "Mobility (Getting around)",
          "Hearing",
          "Eyesight",
          "Using hands/fingers",
          "Learning Difficulty",
          "Mental Health",
          "Other",
        ],
        sexual: [
          "Heterosexual / straight",
          "Gay woman / Lesbian",
          "Gay man",
          "Bisexual",
          "Other",
          "Prefer not to say",
        ],
      },

      questions: {
        section02: {
          Q3_7: {
            questions: [
              "How do you feel about the current layout and space available for cyclists on B4063?",
              "Thinking about yourself and your own cycling abilities, would the B4063 cycleway encourage you to start cycling to Cheltenham, Gloucester, Churchdown or Staverton, or to cycle more often? ",
              "Do you think cycling along the B4063 between the Golf Course and Arle Court Roundabout could be a better experience if the speed limit was lower, from 50mph to 40mph?",
              "Thinking about the wider benefits of the scheme do you think the cycleway along the B4063 will be beneficial to the local community?  ",
            ],
          },
          Q8: {
            questions: [
              "The new cycle route will improve the environment, air quality and tackle climate change",
              "The new Cycleway will help people get around quickly and easily",
              "The new cycleway will help young people to cycle to school",
              "The new Cycleway will provide a place for people to improve their fitness and health",
              "The new Cycleway will help support good mental health for people nearby",
              "The new Cycleway will help people to find alternatives to driving cars for short trips",
              "The new Cycleway will introduce new people to cycling",
              "The new Cycleway will help people without a car to access jobs and training opportunities",
            ],
          },
        },
        section03a: {
          questions: [
            "Do you own a bicycle (or e-bike) at the moment?",
            "Are you, or others in your household, considering getting a bicycle (or e-bike)? ",
            "Do you think that high quality and safe pedestrian and cycle infrastructure will encourage you to walk and cycle (or more often, such as additionally for your commute).  If Yes or Unsure - Please tell us more. If No - What would encourage you to walk or cycle more often",
            "On average how often do you: (one per column)",
            "How would you describe your cycling ability?",
            "Where do you usually cycle?",
            "Do you think more people should take up cycling? ",
            "Would you like to tell us anything about your experience about walking or cycling around the county? ",
          ],
        },
        section03b: {
          questions: [
            "I will walk or cycle more (for all purposes) to support social distancing",
            "I will commute to work less, due to home working",
            "I will use public transport less due to social distancing",
            "I will use public transport less until I have had a vaccine, or infections are lower",
            "I will (or intend to) return to my normal routines after COVID-19 ",
            "I will use a private car more due to COVID-19",
          ],
        },
        section03b_12: [
          "Walk (more than 10 minutes)",
          "Cycle (more than 10 minutes)",
        ],
      },

      answers: {
        section01: [],
        section01_3_comments: "",
        section02_3to7: [],
        section02_text: [],
        section02_8: [],
        section03a_9to10: [],
        section03a_11: { radio: "", comments: "" },
        section03a_12: [],
        section03a_13: "",
        section03a_14: {
          select: "",
          comments: "",
        },
        section03a_14to15: [],
        section03b_17: [],
        section04_18: "",
        section05_1to5: [],
        section05_6: "",
        section05_7: [],
        section05_7_other: "",
        section05_8: "",
      },
    };
  },
  methods: {
    condenseArray() {
      let condenseArray = [];
      this.answers.section05_7.forEach((answer) => {
        condenseArray.push(answer);
      });

      return condenseArray;
    },

    setSectionSubmit(index) {
      this.sectionsSubmitted[index].submitted = true;
    },

    async submitFeedback() {
      let feedbackObj = {
        section01: {
          question01: {
            question:
              "We will manage all data collected through this survey in line with the GCC GDPR policy, are you happy to proceed?",
            answer: this.answers.section01[0]
              ? this.answers.section01[0]
              : "no answer",
          },
          question02: {
            question:
              "Have you read through the information about the scheme on the website, including maps and illustrations of the planned Cycleway?",
            answer: this.answers.section01[1]
              ? this.answers.section01[1]
              : "no answer",
          },
          question03: {
            question: "In what capacity are you responding to this survey?",
            answer: this.answers.section01[2]
              ? this.answers.section01[2]
              : "no answer",
            other: this.answers.section01_3_comments
              ? this.answers.section01_3_comments
              : "n/a",
          },
        },
        section02: {
          question04: {
            question: this.questions.section02.Q3_7.questions[0],
            answer: this.answers.section02_3to7[0]
              ? this.answers.section02_3to7[0]
              : "no answer",
            comments: this.answers.section02_text[0]
              ? this.answers.section02_text[0]
              : "n/a",
          },
          question05: {
            question: this.questions.section02.Q3_7.questions[1],
            answer: this.answers.section02_3to7[1]
              ? this.answers.section02_3to7[1]
              : "no answer",
            comments: this.answers.section02_text[1]
              ? this.answers.section02_text[1]
              : "n/a",
          },
          question06: {
            question: this.questions.section02.Q3_7.questions[2],
            answer: this.answers.section02_3to7[2]
              ? this.answers.section02_3to7[2]
              : "no answer",
            comments: this.answers.section02_text[2]
              ? this.answers.section02_text[2]
              : "n/a",
          },
          question07: {
            question: this.questions.section02.Q3_7.questions[3],
            answer: this.answers.section02_3to7[3]
              ? this.answers.section02_3to7[3]
              : "no answer",
            comments: this.answers.section02_text[3]
              ? this.answers.section02_text[3]
              : "n/a",
          },
          question08: {
            question08_1: {
              question: this.questions.section02.Q8.questions[0],
              answer: this.answers.section02_8[0]
                ? this.answers.section02_8[0]
                : "no answer",
            },
            question08_2: {
              question: this.questions.section02.Q8.questions[1],
              answer: this.answers.section02_8[1]
                ? this.answers.section02_8[1]
                : "no answer",
            },
            question08_3: {
              question: this.questions.section02.Q8.questions[2],
              answer: this.answers.section02_8[2]
                ? this.answers.section02_8[2]
                : "no answer",
            },
            question08_4: {
              question: this.questions.section02.Q8.questions[3],
              answer: this.answers.section02_8[3]
                ? this.answers.section02_8[3]
                : "no answer",
            },
            question08_5: {
              question: this.questions.section02.Q8.questions[4],
              answer: this.answers.section02_8[4]
                ? this.answers.section02_8[4]
                : "no answer",
            },
            question08_6: {
              question: this.questions.section02.Q8.questions[5],
              answer: this.answers.section02_8[5]
                ? this.answers.section02_8[5]
                : "no answer",
            },
            question08_7: {
              question: this.questions.section02.Q8.questions[6],
              answer: this.answers.section02_8[6]
                ? this.answers.section02_8[6]
                : "no answer",
            },
            question08_8: {
              question: this.questions.section02.Q8.questions[7],
              answer: this.answers.section02_8[7]
                ? this.answers.section02_8[7]
                : "no answer",
            },
          },
        },
        section03a: {
          question09: {
            question: this.questions.section03a.questions[0],
            answer: this.answers.section03a_9to10[0]
              ? this.answers.section03a_9to10[0]
              : "no answer",
          },
          question10: {
            question: this.questions.section03a.questions[1],
            answer: this.answers.section03a_9to10[1]
              ? this.answers.section03a_9to10[1]
              : "no answer",
          },
          question11: {
            question: this.questions.section03a.questions[2],
            answer: this.answers.section03a_11.radio
              ? this.answers.section03a_11.radio
              : "no answer",
            comments: this.answers.section03a_11.comments
              ? this.answers.section03a_11.comments
              : "n/a",
          },
          question12: {
            question: this.questions.section03a.questions[3],
            selections: {
              question12_1: {
                question: "Walk (More Than Half A Mile)",
                answer: this.answers.section03a_12[0]
                  ? this.answers.section03a_12[0]
                  : "no answer",
              },
              question12_2: {
                question: "Cycle (More Than Half A Mile)",
                answer: this.answers.section03a_12[1]
                  ? this.answers.section03a_12[1]
                  : "no answer",
              },
            },
          },
          question13: {
            question: this.questions.section03a.questions[4],
            answer: this.answers.section03a_13
              ? this.answers.section03a_13
              : "no answer",
          },
          question14: {
            question: this.questions.section03a.questions[5],
            answer: this.answers.section03a_14.select
              ? this.answers.section03a_14.select
              : "no answer",
            commenst: this.answers.section03a_14.comments
              ? this.answers.section03a_14.comments
              : "n/a",
          },
          question15: {
            question: this.questions.section03a.questions[6],
            answer: this.answers.section03a_14to15[0]
              ? this.answers.section03a_14to15[0]
              : "no answer",
          },
          question16: {
            question: this.questions.section03a.questions[7],
            answer: this.answers.section03a_14to15[1]
              ? this.answers.section03a_14to15[1]
              : "no answer",
          },
        },
        section03b: {
          question01: {
            question: this.questions.section03b.questions[0],
            answers: this.answers.section03b_17[0]
              ? this.answers.section03b_17[0]
              : "no answer",
          },
          question02: {
            question: this.questions.section03b.questions[1],
            answers: this.answers.section03b_17[1]
              ? this.answers.section03b_17[1]
              : "no answer",
          },
          question03: {
            question: this.questions.section03b.questions[2],
            answers: this.answers.section03b_17[2]
              ? this.answers.section03b_17[2]
              : "no answer",
          },
          question04: {
            question: this.questions.section03b.questions[3],
            answers: this.answers.section03b_17[3]
              ? this.answers.section03b_17[3]
              : "no answer",
          },
          question05: {
            question: this.questions.section03b.questions[4],
            answers: this.answers.section03b_17[4]
              ? this.answers.section03b_17[4]
              : "no answer",
          },
          question06: {
            question: this.questions.section03b.questions[5],
            answers: this.answers.section03b_17[5]
              ? this.answers.section03b_17[5]
              : "no answer",
          },
        },
        section04: {
          question17: {
            question:
              "Please provide any additional comments/feedback you have regarding the scheme.",
            answer: this.answers.section04_18
              ? this.answers.section04_18
              : "no answer",
          },
        },
        section05: {
          question18: {
            question: "Gender",
            answer: this.answers.section05_1to5[0]
              ? this.answers.section05_1to5[0]
              : "no answers",
          },
          question19: {
            question: "Gender re-assignment",
            answer: this.answers.section05_1to5[1]
              ? this.answers.section05_1to5[1]
              : "no answers",
          },
          question20: {
            question: "Age",
            answer: this.answers.section05_1to5[2]
              ? this.answers.section05_1to5[2]
              : "no answers",
          },
          question21: {
            question: "Ethnicity",
            answer: this.answers.section05_1to5[3]
              ? this.answers.section05_1to5[3]
              : "no answers",
          },
          question22: {
            question: "Other Ethnicity",
            answer: this.answers.section05_6
              ? this.answers.section05_6
              : "no answers",
          },
          question23: {
            question: "Disability",
            answer: this.answers.section05_1to5[4]
              ? this.answers.section05_1to5[4]
              : "no answers",
          },
          question24: {
            question: "Disability Type",
            answers: this.condenseArray(),
            other: this.answers.section05_7_other
              ? this.answers.section05_7_other
              : "no answers",
          },
          question25: {
            question: "Sexual orientation",
            answers: this.answers.section05_8
              ? this.answers.section05_8
              : "no answers",
          },
        },
      };
      console.log(feedbackObj);
      await this.$store.dispatch("newSubmitFeedback", feedbackObj);
      this.$store.commit("setThankYouState", true);
    },
    ...mapActions(["setThankYouState"]),
    goBack() {
      this.$router.push("homePage");
    },
  },
  computed: {
    ...mapState(["thankYou"]),
    ...mapGetters(["thankYou"]),
  },
};
</script>

<style lang="scss" scoped>
.feedback-section {
  padding-top: 70px;
  padding-bottom: 40px;
}

hr {
  background-color: #1e3556;
  height: 3px;
  border: none;
  margin-top: 30px;
}

.feedback-btn {
  border-radius: 25px;
  font-weight: bold;

  &:hover,
  &:focus {
    border: solid 2px #0055a5;
    background: transparent;
    color: #0055a5;
  }
}

[type="radio"]:not(:checked) {
  opacity: 1;
  position: static;
  width: 20px;
  height: 20px;
}

[type="radio"]:checked {
  position: static;
  opacity: 1;
  width: 20px;
  height: 20px;
}
.feedback {
  li {
    margin: 50px 0;
    color: #0054a4;
    font-weight: bold;
    font-size: 16px;

    p {
      color: #0054a4;
    }

    ul {
      margin-left: 25px;
      li {
        list-style-type: disc;
      }
    }

    .ethnicity {
      li {
        list-style-type: none;
      }
    }

    form {
      &.checkBoxes {
        display: block;

        label {
          margin-right: 20px;
        }
      }
      display: flex;
      flex-flow: row wrap;
      align-items: center;

      label {
        font-weight: 500 !important;
        margin-right: 10px;
        font-size: 16px;
        text-transform: capitalize;
      }

      label::after {
        content: none;
      }
      label::before {
        content: none;
      }

      input {
        vertical-align: middle;
      }

      div {
        margin-right: 20px;
      }

      textarea {
        padding: 5px;
        outline: none;
      }

      .selection-label {
        color: #0054a4;
        font-weight: bold !important;
      }

      select {
        border: solid 1px #0054a4;
        color: #5a5a5a;
        option {
          color: #5a5a5a;
        }
      }
    }
  }
}

.textFeedback {
  border: solid 1px #0054a4;
  padding: 0 20px;
  color: #5a5a5a;

  &::after {
    outline: none;
  }
}

.feedback-text {
  width: 100%;
  height: 200px;
  border: 1px solid #0054a4;
  color: #5a5a5a;
}

.subq1 {
  color: #5a5a5a !important;
}

.subq2 {
  color: #5a5a5a !important;
  font-weight: 400;
}

@media (max-width: 600px) {
  .feedback {
    li {
      form {
        flex-direction: column;
        align-items: stretch;

        div {
          margin-bottom: 20px;
        }

        label {
          padding: 0;
        }
      }
    }
  }
}

.backHome {
  color: white;

  &:hover {
    color: #00669b;
  }
}
</style>